module.exports = __webpack_public_path__ + "static/media/careers-section-2-img.7c3db6f5.png";